<script setup>
import { computed } from 'vue';

const props = defineProps({
  /** 国旗文件名（不含 .svg），对应 src/assets/flags/{code}.svg */
  code: { type: String, required: true },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value),
  },
});

const sizeClass = computed(() => ({
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-6',
}[props.size]));

const src = computed(() => new URL(`../../assets/flags/${props.code}.svg`, import.meta.url).href);
</script>

<template>
  <img
    :src="src"
    :alt="code"
    :class="[sizeClass, 'shrink-0 rounded-full object-cover ring-1 ring-black/10']"
    aria-hidden="true"
  />
</template>
